"use client";
import * as React from "react";
import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { Button } from "./button";
import { Calendar } from "./calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import { cn } from "@repo/utils/utils";
export const DatePicker = React.forwardRef(({ value, onChange, placeholder = "Pick a date", className, disabled }, ref) => {
    const [open, setOpen] = React.useState(false);
    const handleDateSelect = (date) => {
        onChange?.(date);
        // Close the popover immediately when a date is selected
        if (date) {
            setOpen(false);
        }
    };
    return (<Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild disabled={disabled}>
          <Button ref={ref} variant="outline" className={cn("w-full justify-start text-left font-normal", !value && "text-muted-foreground", className)}>
            <CalendarIcon className="mr-2 h-4 w-4"/>
            {value ? format(value, "PPP") : <span>{placeholder}</span>}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar mode="single" selected={value} onSelect={handleDateSelect} initialFocus/>
        </PopoverContent>
      </Popover>);
});
DatePicker.displayName = "DatePicker";
